export default "__VITE_ASSET__D1ohBEBU__"